import React, {useEffect, useState} from 'react'
// Styles
import './applscard.style.css'
// Actions
import { Base_API } from '../../_actions/matcher';
import { EncryptedText, DecryptedText } from '../../utils/Encryption';
import moment from 'moment-timezone';


function AppointListCard({ data }) {
    // console.log('Appoint List: ', data);
    // console.log('Status: ', String(data.strstatus).trim());

    const [isAppoint, setIsAppoint] = useState(false);

    useEffect(() => {
        initData();
    }, [])

    const initData = async() => {
        // เช็คเงื่อนไขปุ่มทำนัด
        const isEndAppoint =  await compareAppointmentEnds();
        if(
            (data.status !== 2 && data.status !== 3) // ต้องเป็น status นี้ถึงจะให้ทำ
            && isEndAppoint === false // หมดเวลาทำนัดหมายแล้วไหม
        )
        {
            setIsAppoint(true);
        }else
        {
            setIsAppoint(false);
        }
    }

    const compareAppointmentEnds = () => {
        return new Promise(async resolve => {
            const appEndTimeStamp = Number(String(data.appendDate).slice(6, data.appendDate.length-2));
            const appEndDate = new Date(appEndTimeStamp);
            const toDay = new Date();
            const duration = moment.duration(moment(appEndDate).diff(toDay));
            const compareSeconds = duration.asSeconds();

            if(compareSeconds <= 0)
            {
                resolve(true); // หมดวันทำนัดแล้ว
            }else
            {
                resolve(false);
            }
        })
    }

    const goToAppointmentPage = async() => {
        await setAppDateTime();

        localStorage.setItem('ishome', EncryptedText(JSON.stringify(data.isshowHome))); //encrypted!
        if(data.isDelivery === true)
        {
            window.location.href = `${Base_API.pathWeb}/n-health/edit-appointment-delivery/${data.id}/${data.campaign}`;
        }else
        {
            window.location.href = `${Base_API.pathWeb}/n-health/edit-appointment/${data.id}/${data.campaign}`;
        }
    }

    const setAppDateTime = () => {
        return new Promise(async resolve => {
            let startDate = EncryptedText(String(data.appstartDate).slice(6, data.appstartDate.length-2));
            let endDate = EncryptedText(String(data.appendDate).slice(6, data.appendDate.length-2));

            localStorage.setItem('appStartDate', startDate);
            localStorage.setItem('appEndDate', endDate);
            resolve();
        })
    }

    return (
        <div 
            className="appls-item"
        >
            {/* top (date & status) */}
            <div className="appls-item-date">
                <span 
                    className={
                        String(data.strstatus).trim() === 'รอทำนัด' ? 'left gray' 
                        : String(data.strstatus).trim() === 'ทำนัดแล้ว' ? 'left green'
                        : String(data.strstatus).trim() === 'รอยืนยันการนัดหมาย' ? 'left orange' : null
                    }
                >
                    {data.strstatus}
                </span>
                <span 
                    className="right"
                >
                    {String(data.strstatus).trim() === 'รอยืนยันการนัดหมาย' &&
                        <a 
                            href={`${Base_API.pathWeb}/n-health/edit-appointment/${data.id}/${data.campaign}`} 
                            className='appls-date-right'
                        >
                            แก้ไขข้อมูล
                        </a>
                    }
                </span>
            </div>
            {/* order number */}
            <p className="order-number">{data.packages_name}</p>
            {/* text (รายการ) */}
            <p className="list">รายละเอียด</p>
            {/* Appoint Detail */}
            <div className="app-detail">
                <div className="item">
                    <span className="label">ผู้รับบริการ</span>
                    <span className="value">{data.Firstname} {data.Lastname}</span>
                </div>
                <div className="item">
                    <span className="label">สถานที่</span>
                    <span className="value">{data.receive_service ? data.receive_service : '-'}</span>
                </div>
                <div className="item">
                    <span className="label">สถานะทำนัด/จัดส่ง</span>
                    <span className="value">{!!data.appointmentDate ? data.appointmentDate : '-'}</span>
                </div>
            </div>
            {/* Button Edit Appoint */}
            {isAppoint === true
                ? 
                <a 
                    onClick={goToAppointmentPage} 
                    className="btn-appoint">ทำนัด
                </a>
                : null
            }
            {/* 0 = ทำนัด 1 = ไม่ทำ */}
        </div>
    )
}
export default AppointListCard